import {Request} from "../request.abstract";
import {Observable} from "rxjs";
import {Blob} from "./api.models";

export class AttachmentsEndpoint extends Request {

    blob(id: number): Observable<Blob> {
        return this.get('/v1/attachments/' + id + '/blob');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/attachments/api.service.ts